import React from "react";

const ErrorText = ({ left = false, message = "", isError = true, className }) => {
  return (
    <div
      className={`error-text ${left ? "error-text-left" : "error-text-right"} ${
        isError ? "error-text-error" : "error-text-normal"
      } ${className || ''}`}
    >
      {message}
    </div>
  );
};

export default ErrorText;
